import React from 'react';
import { CreditCard } from 'lucide-react';
import { Assessment } from '../../types';
import OrderSummary from './OrderSummary';

interface PaymentSummaryProps {
  assessment: Assessment;
  selectedRegions: string[];
  isProcessing: boolean;
  onSubmit: () => void;
}

export default function PaymentSummary({ assessment, selectedRegions, isProcessing, onSubmit }: PaymentSummaryProps) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <div className="space-y-4">
        <OrderSummary 
          assessment={assessment}
          selectedRegions={selectedRegions}
        />

        <button
          onClick={onSubmit}
          disabled={isProcessing}
          className={`
            w-full flex items-center justify-center space-x-2 
            py-3 px-4 rounded-md text-white font-medium
            ${isProcessing 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-brand-primary hover:bg-brand-dark'}
            transition-colors
          `}
        >
          <CreditCard className="w-5 h-5" />
          <span>
            {isProcessing ? 'Processing...' : 'Complete Purchase'}
          </span>
        </button>

        <p className="text-sm text-gray-500 text-center">
          Estimated completion time: {assessment.estimatedTime}
        </p>
      </div>
    </div>
  );
}